import { UsageFeatureProps } from '@employee-experience/common';
import { ILetterGenerationPdf } from '../../models/ILetterGenerationPdf';
import {
  ILetterGenerationRequest,
  ILetterSubmissionRequest,
} from '../../models/ILetterGenerationRequest';
import { ILetterMetadata } from '../../models/ILetterMetadata';
import { ILetterTemplate } from '../../models/ILetterTemplate';
import {
  IReceiveLetterGenerationAction,
  IReceiveLetterGenerationFailedAction,
  IReceiveLetterSubmissionAction,
  IReceiveLetterSubmissionFailedAction,
  IReceiveMetadataAction,
  IReceiveMetadataFailedAction,
  IRequestLetterGenerationAction,
  IRequestLetterSubmissionAction,
  IRequestMetadataAction,
  MetadataActionTypes,
} from '../action-types/metadataActionTypes';

export function requestMetadata(
  feature: UsageFeatureProps,
  selectedTemplate: ILetterTemplate
): IRequestMetadataAction {
  return {
    type: MetadataActionTypes.REQUEST_METADATA,
    feature,
    selectedTemplate,
  };
}

export function receiveMetadata(letterMetadata: ILetterMetadata): IReceiveMetadataAction {
  return {
    type: MetadataActionTypes.RECEIVE_METADATA,
    letterMetadata,
  };
}

export function receiveMetadataFailed(errorMessage: string): IReceiveMetadataFailedAction {
  return {
    type: MetadataActionTypes.REQUEST_METADATA_FAILED,
    errorMessage,
  };
}

export function requestLetterGeneration(
  feature: UsageFeatureProps,
  letterGenerationRequest: ILetterGenerationRequest
): IRequestLetterGenerationAction {
  return {
    type: MetadataActionTypes.REQUEST_LETTER_GENERATION,
    feature,
    letterGenerationRequest,
  };
}

export function receiveLetterGeneration(
  letterPdf: ILetterGenerationPdf
): IReceiveLetterGenerationAction {
  return {
    type: MetadataActionTypes.RECEIVE_LETTER_GENERATION,
    letterPdf,
  };
}

export function receiveLetterGenerationFailed(
  errorMessage: string
): IReceiveLetterGenerationFailedAction {
  return {
    type: MetadataActionTypes.REQUEST_LETTER_GENERATION_FAILED,
    errorMessage,
  };
}

export function requestLetterSubmission(
  feature: UsageFeatureProps,
  letterSubmissionRequest: ILetterSubmissionRequest
): IRequestLetterSubmissionAction {
  return {
    type: MetadataActionTypes.REQUEST_LETTER_SUBMISSION,
    feature,
    letterSubmissionRequest,
  };
}

export function receiveLetterSubmission(crmActivityId: string): IReceiveLetterSubmissionAction {
  return {
    type: MetadataActionTypes.RECEIVE_LETTER_SUBMISSION,
    crmActivityId,
  };
}

export function receiveLetterSubmissionFailed(
  errorMessage: string
): IReceiveLetterSubmissionFailedAction {
  return {
    type: MetadataActionTypes.REQUEST_LETTER_SUBMISSION_FAILED,
    errorMessage,
  };
}
